'use client';

import dynamic from 'next/dynamic';
import React from 'react';
import { FormBuilder } from '@/sanity.types';

// Import the ResourceSearchForm component dynamically with SSR disabled
const ResourceSearchForm = dynamic(() => import('./ResourceSearchForm'), {
  ssr: false,
});

interface DynamicResourceFormProps {
  formData: FormBuilder;
}

export default function DynamicResourceForm({
  formData,
}: DynamicResourceFormProps) {
  return <ResourceSearchForm formData={formData} />;
}
